import { isMobileApp } from "@faire/retailer-visitor-shared/lib/isMobileApp";
import { getSettingAppMigrationAvailable } from "@faire/retailer-visitor-shared/settings/getSettingAppMigrationAvailable";
import { useSettingMigrateRetailerStore } from "@faire/retailer-visitor-shared/settings/useSettingMigrateRetailerStore";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";

import { useIsAppInstalled } from "../pageData/useIsAppInstalled";

const useShowContextualAppDownloadCTAsControl = () => {
  const { showContextualAppDownloadCTAs } = useRetailerStore([
    "showContextualAppDownloadCTAs",
  ]);

  return { showContextualAppDownloadCTAs };
};

const useShowContextualAppDownloadCTAsTreatment = () => {
  const isAppInstalled = useIsAppInstalled();
  const showContextualAppDownloadCTAs =
    isAppInstalled === false &&
    !isMobileApp() &&
    getSettingAppMigrationAvailable();

  return { showContextualAppDownloadCTAs };
};

export const useShowContextualAppDownloadCTAs = () => {
  const shouldUseHooksMigration = useSettingMigrateRetailerStore();
  if (shouldUseHooksMigration) {
    // eslint-disable-next-line react-compiler/react-compiler, react-hooks/rules-of-hooks
    return useShowContextualAppDownloadCTAsTreatment();
  }
  // eslint-disable-next-line react-compiler/react-compiler, react-hooks/rules-of-hooks
  return useShowContextualAppDownloadCTAsControl();
};
